<template>
    <div class="d-flex flex-column align-items-center">
        <app-sub-title :text="title"></app-sub-title>
        <div class="chart">
            <GChart
                :ref="id"
                :settings="{ packages: ['corechart', 'gauge'] }"
                type="Gauge"
                :data="chartData"
                :options="chartOptions"
            ></GChart>
        </div>
    </div>
</template>
<script>
import { GChart } from 'vue-google-charts'
export default {
    components: {
        GChart,
    },
    props: {
        id: {
            type: String,
            default: () => `gauge-${Math.random() * 1000000}`,
        },
        indicator: {
            type: Number,
            default: 0,
        },
        green: {
            type: Object,
            default: () => ({ from: 90, to: 100 }),
        },
        yellow: {
            type: Object,
            default: () => ({ from: 80, to: 89 }),
        },
        red: {
            type: Object,
            default: () => ({ from: 0, to: 79 }),
        },
        name: {
            type: String,
            default: 'Indicador',
        },
        width: {
            type: Number,
            default: 400,
        },
        height: {
            type: Number,
            default: 120,
        },
        title: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        chartOptions: null,
        chartData: [],
    }),
    watch: {
        indicator(val) {
            this.setChartData()
        },
    },
    computed: {},
    methods: {
        setChartData() {
            const chartData = [
                ['Label', 'Value'],
                [this.name, this.indicator],
            ]
            this.chartData = chartData
        },
        setChartOptions() {
            const chartOptions = {
                width: this.width,
                height: this.height,
                redFrom: this.red.from,
                redTo: this.red.to,
                yellowFrom: this.yellow.from,
                yellowTo: this.yellow.to,
                greenFrom: this.green.from,
                greenTo: this.green.to,
                minorTicks: 5,
            }

            this.chartOptions = chartOptions
        },
    },
    mounted() {
        this.setChartData()
        this.setChartOptions()
    },
}
</script>
